/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import verifCertifActions, {
    verifCertifTypes,
} from '../../../redux/demande/verifCertif'
import { Get } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* verifCertifSagas({ response }) {
    try {
        const res = yield Get(
            `demande/attestation_public/?numero_attestation=${response.certifNumber}&numero_cin=${response.identityNumber}&date_naissance=${response.birthDate}`
        )
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(verifCertifActions.verifCertifSuccess(res.data)),
            ])
            if (res.data.preview === 'true') {
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                )
                // yield put(goBack())
            }
        } else {
            yield put(verifCertifActions.verifCertifFailure(res))
        }
    } catch (error) {
        yield put(verifCertifActions.verifCertifFailure(error))
    }
}

export function* verifCertifSaga() {
    yield takeLatest(verifCertifTypes.VERIF_CERTIF_REQUEST, verifCertifSagas)
}
